import {getSetting, getPage} from '@wc-stripe/utils';
import actions from '@wc-stripe/actions';
import {ProductMessage, CartMessage, ShopMessage, CheckoutMessage} from '../../messages';

const page = getPage();
const bnplMessages = getSetting('bnplMessages') || {};

const messageClasses = {
    product: ProductMessage,
    cart: CartMessage,
    checkout: CheckoutMessage
};

const createMessage = (MessageClass, props) => {
    const message = new MessageClass(props);
    message.initialize();
};

if (page === 'shop') {
    const shopProducts = getSetting('bnplShopProducts') || [];
    for (const product of shopProducts) {
        createMessage(ShopMessage, {
            actions,
            location: bnplMessages.locations.shop,
            data: product,
            settings: {
                ...bnplMessages,
                paymentMethods: product.paymentMethods,
                selector: `#wc-stripe-bnpl-shop-msg-${product.id}`,
            },
        });
    }
} else if (messageClasses[page]) {
    createMessage(messageClasses[page], {
        actions,
        location: bnplMessages.locations[page],
        settings: bnplMessages
    });
}